import React from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import { getQuestionTypes, mayQuestionHaveOptions } from 'helpers/questionnaire';

import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormSwitchery from 'components/forms/FormSwitchery';
import FormRichEditor from 'components/forms/FormRichEditor';

import QuestionnaireQuestionOptionDraggable from 'components/layout/questionnaire/QuestionnaireQuestionOptionDraggable';

class Question extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      editingOption: false,
      editedOptionIndex: null,
    };
  }

  updateEntity = (propertyName, value) => {
    const { updateEntity, questionIndex } = this.props;
    updateEntity(propertyName, value, ['questions', questionIndex]);
  };

  formSubmit = e => {
    e.preventDefault();

    const { onSubmitParent } = this.props;
    if (onSubmitParent) {
      onSubmitParent();
    }
  };

  addOption = () => {
    const {
      intl: { messages },
      entity,
      questionIndex,
      updateEntity,
    } = this.props;

    const newOption = entity.createValue('options', ['questions', questionIndex], { label: messages.title });
    const newOptionsArray = entity
      .getQuestions()
      [questionIndex].getOptions()
      .slice();
    newOptionsArray.push(newOption);

    updateEntity('options', newOptionsArray, ['questions', questionIndex]);
  };

  updateOption = (name, value) => {
    const { questionIndex, updateEntity } = this.props;
    const { editedOptionIndex } = this.state;
    updateEntity(name, value, ['questions', questionIndex, 'options', editedOptionIndex]);
  };

  startEditingOption = editedOptionIndex => {
    this.setState({ editingOption: true, editedOptionIndex });
  };

  finishEditingOption = () => {
    this.setState({ editingOption: false });
  };

  removeOption = index => {
    const { entity, questionIndex, updateEntity } = this.props;

    const newOptionsArray = entity
      .getQuestions()
      [questionIndex].getOptions()
      .slice();
    newOptionsArray.splice(index, 1);

    updateEntity('options', newOptionsArray, ['questions', questionIndex]);
  };

  moveOption = (dragIndex, hoverIndex) => {
    const { entity, questionIndex, updateEntity } = this.props;

    const newOptionsArray = entity
      .getQuestions()
      [questionIndex].getOptions()
      .slice();
    const tmpValue = { ...newOptionsArray[hoverIndex] };
    newOptionsArray[hoverIndex] = { ...newOptionsArray[dragIndex] };
    newOptionsArray[dragIndex] = tmpValue;

    updateEntity('options', newOptionsArray, ['questions', questionIndex]);
  };

  render() {
    const {
      intl: { messages },
      intl,
      entity,
      questionIndex,
    } = this.props;
    const { editingOption, editedOptionIndex } = this.state;

    const question = entity.getQuestions()[questionIndex];

    let isRequiredChecked = question.getIsRequired();
    let isRequiredDisabled = false;
    let showInLeadDescriptionChecked = question.getShowInLeadDescription();
    let showInLeadDescriptionDisabled = false;

    if (question.getType() === 'client_data') {
      isRequiredChecked = true;
      isRequiredDisabled = true;
      showInLeadDescriptionChecked = true;
      showInLeadDescriptionDisabled = true;
    }

    return (
      <Row>
        <Col xs={12}>
          <form onSubmit={this.formSubmit}>
            <div className="panel panel-transparent">
              <div className="panel-body">
                <p className="form-group-title">{messages.question}</p>
                <div className="form-group-attached">
                  <FormInput
                    label={messages.title}
                    name="label"
                    value={question.getLabel()}
                    meta={question.getLabelMetaInformation()}
                    validation={question.getLabelValidationResult()}
                    onChange={this.updateEntity}
                  />
                  <FormAutocomplete
                    label={messages.type}
                    name="type"
                    value={question.getType()}
                    options={getQuestionTypes(messages)}
                    meta={question.getTypeMetaInformation()}
                    validation={question.getTypeValidationResult()}
                    onChange={this.updateEntity}
                  />
                  <div className="form-group form-group-default padding-10">
                    <FormSwitchery
                      name="isRequired"
                      label={messages.required}
                      checked={isRequiredChecked}
                      value
                      onChange={this.updateEntity}
                      disabled={isRequiredDisabled}
                    />
                  </div>
                  <div className="form-group form-group-default padding-10">
                    <FormSwitchery
                      name="showInLeadDescription"
                      label={messages.show_in_lead_description}
                      checked={showInLeadDescriptionChecked}
                      value
                      onChange={this.updateEntity}
                      disabled={showInLeadDescriptionDisabled}
                    />
                  </div>
                  {question.getType() === 'paragraph' && (
                    <FormRichEditor
                      name="content"
                      label={messages.content}
                      value={question.getContent()}
                      onChange={this.updateEntity}
                    />
                  )}
                </div>

                {mayQuestionHaveOptions(question.getType()) && (
                  <React.Fragment>
                    <p className="m-t-15">{messages.options}</p>

                    {question.getOptions().length > 0 &&
                      question.getOptions().map((option, i) => {
                        return (
                          <QuestionnaireQuestionOptionDraggable
                            key={i}
                            index={i}
                            intl={intl}
                            id={option.getId()}
                            label={option.getLabel()}
                            updateOption={this.updateOption}
                            moveOption={this.moveOption}
                            removeOption={this.removeOption}
                            editingOption={editingOption}
                            editedOptionIndex={editedOptionIndex}
                            startEditingOption={this.startEditingOption}
                            finishEditingOption={this.finishEditingOption}
                          />
                        );
                      })}

                    <div class="m-t-10">
                      <Button onClick={this.addOption}>{messages.add_option}</Button>
                    </div>
                  </React.Fragment>
                )}

                <div className="text-right m-t-15">
                  <Button bsSize="lg" disabled={false} type="submit" bsStyle="default">
                    <i className="far fa-fw fa-save" /> {messages.save}
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Col>
      </Row>
    );
  }
}

export default injectIntl(Question);
